import React from "react";
import Routes from "./Routes";
import { AppConfigProvider } from "./lib/AppConfigContext";
import { ToastProvider } from "./lib/ToastContext";

function App() {
  return (
    <AppConfigProvider>
      <ToastProvider>
        <Routes />
      </ToastProvider>
    </AppConfigProvider>
  );
}

export default App;
